import React from 'react';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

const FormInput = (props: any) => <input {...props} error={`${props.error}`} data-i={props.dataI} />;

const FormInputStyle = ({ width, error }) => css`
  ${mq({
    fontSize: '1rem',
    height: ['56px'],
    borderRadius: '8px',
    borderStyle: 'solid',
    borderWidth: '1px',
    width: width ? width : '100%',
    padding: '0 10px',
    color: `${Colors.neutral75}`,
    borderColor: `${error ? Colors.redLight1 : Colors.grayLight9}`,
    backgroundColor: `${error ? Colors.redLight4 : Colors.neutral0}`,
  })};
  &:hover {
    border-color: #72c600;
  }
  &:focus {
    border-color: #72c600;
  }
  &:disabled {
    background-color: #dfe3e8;
  }
`;

const FormInputStyled = styled(FormInput)`
  ${FormInputStyle}
`;

export { FormInputStyled as FormInput };
